import { render } from "./BannerSuccess.vue?vue&type=template&id=78a4352c"
import script from "./BannerSuccess.vue?vue&type=script&lang=js"
export * from "./BannerSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__